import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installErrorReporter } from "@/utils/errorReporter";

// Wire global frontend error capture — forwards window.onerror + unhandledrejection
// to POST /api/errors/report so JS crashes appear in the Admin Error Log.
installErrorReporter();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
